import React from "react";

export type GenderIconProps = {
  /**
   * Width of the logo
   * if you overrides width + height, 'size' props will be ignored
   */
  width?: number;
  /**
   * Height of the logo
   * if you overrides width + height, 'size' props will be ignored
   */
  height?: number;
  /**
   * Choose between them value
   * @default black
   */
  color?: string;
  /**
   * The size of the logo
   * small: 122*46 | medium: 155*60 | large: 217*83
   * @default medium
   */
  size?: "small" | "medium" | "large";
};

const sizes = {
  small: {
    width: 24,
    height: 24,
  },
  medium: {
    width: 24,
    height: 24,
  },
  large: {
    width: 24,
    height: 24,
  },
};

export const GenderIcon = React.forwardRef<SVGSVGElement, GenderIconProps>(
  (props, ref) => {
    const { size = "medium", width, height, color = "#E01B3F" } = props;
    const svgSize = width && height ? { width, height } : sizes[size];
    return (
      <svg
        ref={ref}
        width={svgSize.width}
        height={svgSize.height}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M18.0031 1.19995C17.6056 1.19995 17.2831 1.52246 17.2831 1.91995C17.2831 2.31744 17.6056 2.63995 18.0031 2.63995H20.3431L17.2606 5.72251C16.1149 4.70345 14.6112 4.08 12.9631 4.08C12.0237 4.08 11.1303 4.28063 10.3231 4.64251C9.51593 4.28064 8.62251 4.08 7.68312 4.08C4.11312 4.08 1.20312 6.99 1.20312 10.56C1.20312 13.8862 3.73056 16.6416 6.96312 17.0026V18.72H5.04312C4.64564 18.72 4.32312 19.0426 4.32312 19.44C4.32312 19.8375 4.64564 20.16 5.04312 20.16H6.96312V22.08C6.96312 22.4775 7.28564 22.8 7.68312 22.8C8.08061 22.8 8.40312 22.4775 8.40312 22.08V20.16H10.3231C10.7206 20.16 11.0431 19.8375 11.0431 19.44C11.0431 19.0426 10.7206 18.72 10.3231 18.72H8.40312V17.0026C9.07906 16.9276 9.72593 16.7457 10.3231 16.4776C11.1303 16.8394 12.0237 17.0401 12.9631 17.0401C16.5331 17.0401 19.4431 14.1301 19.4431 10.5601C19.4431 9.15475 18.9931 7.85071 18.2281 6.78751L21.363 3.65263L21.3555 5.99263L22.7955 6.00013L22.803 1.92013C22.803 1.52264 22.4805 1.20013 22.083 1.20013L18.0031 1.19995ZM22.7957 5.99995H21.3632C21.3632 6.39744 21.6857 6.71995 22.0832 6.71995C22.4807 6.71995 22.8032 6.39744 22.8032 5.99995H22.7957ZM7.68312 5.51995C8.05438 5.51995 8.41532 5.56495 8.76312 5.63995C7.37187 6.82963 6.48312 8.59219 6.48312 10.56C6.48312 12.5277 7.37187 14.2903 8.76312 15.48C8.41532 15.555 8.05438 15.6 7.68312 15.6C4.8912 15.6 2.64312 13.3518 2.64312 10.56C2.64312 7.76808 4.89125 5.51995 7.68312 5.51995ZM12.9631 5.51995C15.755 5.51995 18.0031 7.76808 18.0031 10.56C18.0031 13.3518 15.755 15.6 12.9631 15.6C12.5919 15.6 12.2309 15.555 11.8831 15.48C13.2744 14.2903 14.1631 12.5277 14.1631 10.56C14.1631 8.59219 13.2744 6.82963 11.8831 5.63995C12.2309 5.56495 12.5919 5.51995 12.9631 5.51995ZM10.3231 6.26995C11.7622 7.15589 12.7231 8.73931 12.7231 10.56C12.7231 12.3806 11.7622 13.9641 10.3231 14.85C8.88406 13.964 7.92312 12.3806 7.92312 10.56C7.92312 8.73931 8.88406 7.15579 10.3231 6.26995Z"
          fill={color}
        />
      </svg>
    );
  }
);

GenderIcon.displayName = "GenderIcon";
